import { render, staticRenderFns } from "./pos_empty.vue?vue&type=template&id=98875fcc&scoped=true&"
import script from "./pos_empty.vue?vue&type=script&lang=js&"
export * from "./pos_empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98875fcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98875fcc')) {
      api.createRecord('98875fcc', component.options)
    } else {
      api.reload('98875fcc', component.options)
    }
    module.hot.accept("./pos_empty.vue?vue&type=template&id=98875fcc&scoped=true&", function () {
      api.rerender('98875fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/pos/pos_empty.vue"
export default component.exports